var BaseMsgItem = require('./BaseMsgItem');
var $ = require('jQuery');
var dispatcher = require('./../../global/dispatcher');
var ActionType = require('./../../constant/ActionType');
var template = require('./../../template/msg/chatcard-msg-item.html');
var paragraph = '<p class="im-chat-msg-name">${name}:</p><p class="im-chat-msg-content">${message}</p>';

var ChatCardItem = function (options) {
  (function (self) {
    var defaults = {
      template: template
    };
    $.extend(defaults, options);
    BaseMsgItem.call(self, defaults);
  })(this);
};

ChatCardItem.prototype = Object.create(BaseMsgItem.prototype);
ChatCardItem.prototype.renderContent = function () {
  var msg = this._data.msg;
  if (!msg) {
    return false;
  }
  var batch_body = '';
  var msgcontent = msg.content;
  var element = this._element;
  (msgcontent || []).forEach(function (message, index) {
    batch_body += paragraph.replace('${name}', message.name).replace('${message}', message.msg_content);
  });
  var $content = element.find('.im-chat-msg-contents');
  $content.html(batch_body);
  $content.click(function (e) {
    e.stopPropagation();
    msg.msgs.forEach(msgMsg => {
      if (typeof msgMsg.content=== 'string') {
        msgMsg.content = JSON.parse(msgMsg.content);
      }
      if(msgMsg.content.type == "msg_batch_forward_card"){
        msgMsg.forward_msgs = msg.forward_msgs;
        msgMsg.msg_collect = 'collect';
      }
    });
    dispatcher.dispatch({
      type: ActionType.COLLECTION_MESSAGE_FLOAT,
      data: {
        msgList: msg.msgs,
        title: msg.title,
        id: msg.msg_id,
        parent_u_key:msg.content._parent_u_key ? msg.content._parent_u_key:''
      }
    });
  });
};

module.exports = ChatCardItem;